/**
 * @generated SignedSource<<2b33dd41f56c808f8156d01c20e57e11>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InvoiceState = "DRAFT" | "INVOICE_NUMBER_PENDING" | "OPEN" | "PAID" | "REFUNDED" | "REVERSED" | "UNCOLLECTIBLE" | "VOID" | "%future added value";
export type InvoiceViewQuery$variables = {
  id: string;
};
export type InvoiceViewQuery$data = {
  readonly invoice: {
    readonly id: string;
    readonly state: InvoiceState;
    readonly " $fragmentSpreads": FragmentRefs<"DraftInvoiceView_invoice" | "FinalInvoiceView_invoice">;
  } | null | undefined;
};
export type InvoiceViewQuery = {
  response: InvoiceViewQuery$data;
  variables: InvoiceViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "invoiceNumber",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentMethodType",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "paymentServiceType",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cardBrand",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastFourDigits",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "succeededAt",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "InvoiceViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Invoice",
        "kind": "LinkedField",
        "name": "invoice",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DraftInvoiceView_invoice"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "FinalInvoiceView_invoice"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "InvoiceViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Invoice",
        "kind": "LinkedField",
        "name": "invoice",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "type",
            "storageKey": null
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CustomerAccount",
            "kind": "LinkedField",
            "name": "customerAccount",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerName",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "customerNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vatId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taxStatus",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "relatedInvoiceIdentifier",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "language",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taxType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceLineItem",
            "kind": "LinkedField",
            "name": "lineItems",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "quantity",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "unitLabel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "description",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "price",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taxRatePercentage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "invoiceDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeOfPerformanceStart",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "timeOfPerformanceEnd",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "taxTypeNote",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BusinessAddress",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "businessName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "addressLine1",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "addressLine2",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postalCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "country",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "paymentNote",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PaymentMethod",
            "kind": "LinkedField",
            "name": "paymentMethod",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "paymentTerms",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expirationDate",
                "storageKey": null
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "purchaseOrderReference",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "customerOrderNotes",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "InvoiceAttachment",
            "kind": "LinkedField",
            "name": "attachments",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sha1",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "filename",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "size",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Invoice",
            "kind": "LinkedField",
            "name": "relatedInvoice",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sentAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dueDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "updatedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "documentSha1",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "documentRenderedAt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "documentRenderedVersion",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalGrossAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PaymentIntent",
            "kind": "LinkedField",
            "name": "paymentIntents",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canceledAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "scheduledFor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Charge",
                "kind": "LinkedField",
                "name": "charges",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "paid",
                    "storageKey": null
                  },
                  (v10/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "disputed",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "refunded",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentMethod",
                    "kind": "LinkedField",
                    "name": "paymentMethod",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "chargeFailureCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "chargeFailureMessage",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Refund",
            "kind": "LinkedField",
            "name": "refunds",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v9/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "amount",
                "storageKey": null
              },
              (v10/*: any*/),
              (v11/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6366a1df9a98b862c3ebbbe594ee064b",
    "id": null,
    "metadata": {},
    "name": "InvoiceViewQuery",
    "operationKind": "query",
    "text": "query InvoiceViewQuery(\n  $id: ID!\n) {\n  invoice(id: $id) {\n    id\n    state\n    ...DraftInvoiceView_invoice\n    ...FinalInvoiceView_invoice\n  }\n}\n\nfragment CreateReverseInvoiceDialog_invoice on Invoice {\n  id\n  invoiceNumber\n  customerAccount {\n    customerName\n    id\n  }\n}\n\nfragment DraftInvoiceView_invoice on Invoice {\n  ...InvoiceHeader_invoice\n  ...InvoiceLineItemsTable_invoice\n  ...FinalizeInvoiceDialog_invoice\n  id\n  type\n  state\n  invoiceNumber\n  invoiceDate\n  timeOfPerformanceStart\n  timeOfPerformanceEnd\n  language\n  taxType\n  taxTypeNote\n  customerAccount {\n    customerNumber\n    vatId\n    taxStatus\n    id\n  }\n  address {\n    businessName\n    addressLine1\n    addressLine2\n    postalCode\n    city\n    country\n  }\n  paymentNote\n  paymentMethod {\n    id\n    paymentMethodType\n    paymentServiceType\n    paymentTerms\n    cardBrand\n    expirationDate\n    lastFourDigits\n  }\n  purchaseOrderReference\n  customerOrderNotes\n  attachments {\n    sha1\n    filename\n    size\n  }\n  relatedInvoice {\n    id\n    invoiceNumber\n  }\n}\n\nfragment FinalInvoiceView_invoice on Invoice {\n  ...InvoiceHeader_invoice\n  ...InvoiceLineItemsTable_invoice\n  ...InitiateInvoicePaymentDialog_invoice\n  ...SendInvoiceDialog_invoice\n  ...CreateReverseInvoiceDialog_invoice\n  id\n  type\n  version\n  invoiceNumber\n  invoiceDate\n  dueDate\n  updatedAt\n  state\n  timeOfPerformanceStart\n  timeOfPerformanceEnd\n  language\n  taxType\n  taxTypeNote\n  customerAccount {\n    customerNumber\n    vatId\n    taxStatus\n    id\n  }\n  address {\n    businessName\n    addressLine1\n    addressLine2\n    postalCode\n    city\n    country\n  }\n  paymentNote\n  paymentMethod {\n    id\n    paymentMethodType\n    paymentServiceType\n    paymentTerms\n    cardBrand\n    expirationDate\n    lastFourDigits\n  }\n  purchaseOrderReference\n  customerOrderNotes\n  attachments {\n    sha1\n    filename\n    size\n  }\n  documentSha1\n  documentRenderedAt\n  documentRenderedVersion\n  sentAt\n  totalGrossAmount\n  paymentIntents {\n    id\n    status\n    createdAt\n    succeededAt\n    canceledAt\n    scheduledFor\n    charges {\n      state\n      id\n      paid\n      createdAt\n      disputed\n      refunded\n      paymentMethod {\n        paymentMethodType\n        paymentServiceType\n        cardBrand\n        lastFourDigits\n        id\n      }\n    }\n    chargeFailureCode\n    chargeFailureMessage\n  }\n  refunds {\n    id\n    status\n    amount\n    createdAt\n    succeededAt\n  }\n  relatedInvoice {\n    id\n    invoiceNumber\n  }\n}\n\nfragment FinalizeInvoiceDialog_invoice on Invoice {\n  id\n  customerAccount {\n    customerName\n    id\n  }\n}\n\nfragment InitiateInvoicePaymentDialog_invoice on Invoice {\n  id\n  invoiceNumber\n  paymentMethod {\n    paymentMethodType\n    cardBrand\n    lastFourDigits\n    id\n  }\n  sentAt\n}\n\nfragment InvoiceHeader_invoice on Invoice {\n  id\n  type\n  invoiceNumber\n  customerAccount {\n    customerName\n    id\n  }\n  relatedInvoiceIdentifier\n}\n\nfragment InvoiceLineItemsTable_invoice on Invoice {\n  id\n  type\n  language\n  taxType\n  lineItems {\n    quantity\n    unitLabel\n    description\n    price\n    taxRatePercentage\n  }\n}\n\nfragment SendInvoiceDialog_invoice on Invoice {\n  id\n  sentAt\n}\n"
  }
};
})();

(node as any).hash = "aa30c36fe176d52866768104de0ca9ad";

export default node;
